import { isObject } from "lodash-es";
export const loginExpireCheck = async (ctx, next) => {
  try {
    const {
      requestConfig
    } = ctx;
    requestConfig.headers = {
      ...requestConfig.headers,
      'X-Requested-With': 'XMLHttpRequest'
    };
    await next();
  } catch (error) {
    if (!isObject(error)) {
      throw error;
    }
    console.log('login error', error);
    const {
      response
    } = error;
    if (!response) {
      return;
    }
    if (response.status === 401) {
      var _window$xy_runtime_ut, _window$xy_runtime_ut2;
      (_window$xy_runtime_ut = window.xy_runtime_utils) === null || _window$xy_runtime_ut === void 0 || (_window$xy_runtime_ut2 = _window$xy_runtime_ut.reLogin) === null || _window$xy_runtime_ut2 === void 0 ? void 0 : _window$xy_runtime_ut2.call(_window$xy_runtime_ut);
    }
    throw error;
  }
};
//# sourceMappingURL=handleLogin.js.map
